import { render, staticRenderFns } from "./MottoMission.vue?vue&type=template&id=6efab957&"
import script from "./MottoMission.vue?vue&type=script&lang=js&"
export * from "./MottoMission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports